import api from "./index";

export const approvalDocumentsService = async (eventId, params = {}) => {
  return await api.get(`/upload-flow/event/${eventId}/documents`, {
    params,
  });
};

export const uploadMassStatusReportFormService = async (token, data) => {
  return await api.post(`/async/upload-mass-status-report/form`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getUploadMassStatusReportService = async (token, reportId) => {
  return await api.get(`/async/upload-mass-status-report/${reportId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
